import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navigation.css";

function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Link to="/" className="logo">
        Azteq
      </Link>

      <button
        className={`menu-button ${isOpen ? "active" : ""}`}
        onClick={toggleMenu}
      >
        <div className="menu-icon">
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </button>

      <div className={`nav-overlay ${isOpen ? "active" : ""}`}>
        <nav className={`nav-menu ${isOpen ? "active" : ""}`}>
          <Link to="/" onClick={toggleMenu}>Home</Link>
          <Link to="/chat" onClick={toggleMenu}>Chat</Link>
          <Link to="/about" onClick={toggleMenu}>About</Link>
          <Link to="/contact" onClick={toggleMenu}>Contact</Link>
        </nav>
      </div>
    </>
  );
}

export default Navigation;
